<template>
    <div class="card">
        <div class="card-header">Hersteller ausblenden</div>
        <div class="card-body">
            <SelectManufacturer v-model="manufacturerInput"></SelectManufacturer>
        </div>
    </div>
</template>

<script>
import SelectManufacturer from "@/views/shared/widgets/SelectManufacturer";

export default {
    name: "TableFilter",
    components: { SelectManufacturer },
    data: function() {
        return {
            manufacturerInput: []
        };
    },
    watch: {
        manufacturerInput() {
            this.$store.commit("setFilterManufacturer", this.manufacturerInput);
        }
    }
};
</script>

<style scoped></style>
